import { HomePage, InternalLinkBlock, LandingPage } from "graphql/generated-types";
import Image from "next/image";
import Button from "./Button";
import clsx from "clsx";

type HeroProps = {
	page: HomePage | LandingPage;
};

const Hero: React.FC<HeroProps> = ({ page }) => {
	const heroLinks = page?.heroLinks! as InternalLinkBlock[];
	const introLinks = page?.introLinks! as InternalLinkBlock[];
	return (
		<>
			<div className="relative h-[50vh] pb-16 lg:h-screen lg:min-h-[760px]">
				<Image
					className="absolute z-[-1] h-full w-full object-cover"
					src={page?.heroImage?.rendition?.url!}
					alt={page?.heroImage?.rendition?.image?.title!}
					height={page?.heroImage?.rendition?.height}
					width={page?.heroImage?.rendition?.width}
				/>
				<div className="absolute inset-0 z-[-1] bg-[#A6A6A6] mix-blend-multiply"></div>
			</div>
			<div className="bg-blue -mt-16 mb-20 rounded-lg pb-12 lg:-mt-28 lg:mb-44 lg:rounded-[120px] lg:py-40">
				<div className="container flex h-full flex-col justify-end pt-9 lg:absolute lg:left-1/2 lg:top-0 lg:min-h-[760px] lg:-translate-x-1/2 lg:pb-48">
					<h3 className="mb-11 text-[30px] font-light leading-snug text-white lg:text-[60px] lg:leading-tight xl:w-3/4 2xl:text-[70px]">
						{page.heroTagline}
					</h3>
					{heroLinks.length > 0 && (
						<div
							className={clsx(
								"grid grid-flow-col gap-4 md:grid-cols-2 lg:gap-x-10 lg:gap-y-7 2xl:grid-cols-4",
								introLinks.length > 0 ? "to-lg:mb-32" : "to-lg:mb-10",
							)}
						>
							{heroLinks?.map((link) => (
								<Button key={link!.id} link={link?.href} extraClasses="col-start-1 max-w-[330px]">
									{link?.text}
								</Button>
							))}
						</div>
					)}
				</div>
				<div className="container text-white">
					{introLinks.length > 0 && (
						<div className="mb-20 grid gap-4 md:grid-cols-2 lg:mb-32 lg:grid-cols-4 lg:gap-10">
							{introLinks?.map((link) => (
								<Button key={link!.id} link={link?.href} secondary>
									{link?.text}
								</Button>
							))}
						</div>
					)}
					<div className="mb-10 text-base lg:text-2xl lg:leading-snug">{page.introText}</div>
					<a className="decoration-cyan underline underline-offset-8" href={page?.learnMoreLink!}>
						{page.learnMoreLabel}
					</a>
				</div>
			</div>
		</>
	);
};

export default Hero;
